<!-- 对话框 -->
<template>
  <el-dialog
    v-model="dialogVisible"
    v-bind="$attrs"
    append-to-body
    :before-close="beforeClose"
    :body-class="
      ['ai-dialog-container__body', `ai-dialog-container__body--padding-${padding}`].join(' ')
    "
    class="ai-dialog-container"
    :close-on-click-modal="false"
    destroy-on-close
    footer-class="ai-dialog-container__footer"
    header-class="ai-dialog-container__header"
    :width="isMobile() ? '80%' : width"
  >
    <!-- 标题插槽 -->
    <template #header> <slot name="header"></slot> </template>

    <!-- 内容插槽 -->
    <slot></slot>

    <!-- 底部操作区域 -->
    <template v-if="showFooter" #footer>
      <div v-if="!$slots.footer && isMobile()" class="btn">
        <div v-if="showCancelBtn" class="btn-item" @click="handleCancelClick">
          {{ cancelBtnText }}
        </div>
        <div
          v-if="showConfirmBtn"
          class="btn-item"
          :style="{ 'border-left': showConfirmBtn && showCancelBtn && '1px solid #e5e6eb' }"
          @click="handleConfirmClick"
        >
          {{ confirmBtnText }}
        </div>
      </div>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { isMobile } from '@/utils'

const emits = defineEmits(['update:show', 'confirm', 'cancel'])
const props = defineProps({
  // 对话框显示状态
  show: {
    type: Boolean,
    default: false
  },
  // 对话框宽度
  width: {
    type: [String, Number],
    default: 400
  },
  // 是否显示确认按钮(仅移动端有效)
  showConfirmBtn: {
    type: Boolean,
    default: true
  },
  // 是否显示取消按钮(仅移动端有效)
  showCancelBtn: {
    type: Boolean,
    default: true
  },
  // 确认按钮文字(仅移动端有效)
  confirmBtnText: {
    type: String,
    default: '确认'
  },
  // 取消按钮文字(仅移动端有效)
  cancelBtnText: {
    type: String,
    default: '取消'
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  padding: {
    type: [Number],
    default: 24
  },
  beforeClose: {
    type: Function,
    default: (done) => {
      done()
    }
  }
})

// 本地对话框显示状态
const dialogVisible = computed({
  get: () => props.show,
  set: (val) => emits('update:show', val)
})

// 禁用默认属性继承（防止重复绑定）
defineOptions({
  inheritAttrs: false
})

/**
 * 处理取消按钮点击
 */
const handleCancelClick = () => {
  emits('cancel')
  dialogVisible.value = false
}
/**
 * 处理确认按钮点击
 */
const handleConfirmClick = () => {
  emits('confirm')
  dialogVisible.value = false
}
</script>

<style lang="scss" scoped></style>

<style lang="scss">
$fontFamily: 'PingFang SC';

.ai-dialog-container {
  max-height: 600px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.1);

  &__header {
    padding: 12px 24px !important;
    border-bottom: none !important;
    font-family: $fontFamily;
    font-size: 14px;
  }

  &__body {
    overflow: auto;
    font-family: $fontFamily !important;
    font-size: 14px;
    letter-spacing: -0.01em;
    color: #323233;
  }

  &__body--padding-24 {
    padding: 0 24px !important;
  }

  &__body--padding-0 {
    padding: 0 !important;
  }

  &__footer {
    height: auto !important;
    line-height: unset !important;
    padding: 12px 24px !important;
    border-top: none !important;

    .btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #e5e6eb;
      margin: 0 -24px -20px -24px;

      .btn-item {
        flex: 1;
        padding: 12px 0;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        line-height: normal;
        text-align: center;
        letter-spacing: 0em;

        &:first-child {
          color: #323233;
        }

        &:last-child {
          color: #7a52f4;
        }
      }
    }
  }
}
</style>
